export default __webpack_public_path__ + "static/media/Badge4.7ade17fd.png";